import { Component } from 'react';
import { isEqual } from 'lodash';
import { WithStyles, withStyles } from '@mui/styles';
import { COMPONENT_DEFINITIONS } from './definitions/components';
import { withTranslate } from '../../../core/TenantProvider';

import APReferralStepPanelStyles from './styles/APReferralStepPanel.style';

interface APReferralStepPanelProps extends WithStyles<typeof APReferralStepPanelStyles> {
	definition: any,
	form: any,
	onBlur?: any,
	onChange?: any,
	onValidStateChange: any,
	touched: any,
	translate: any,
	showEmail: any
}

class APReferralStepPanel extends Component<APReferralStepPanelProps, {}> {
	componentDidMount() {
		this.validate();
	}

	componentDidUpdate(prevProps: APReferralStepPanelProps) {
		const shouldValidate = (
			!isEqual(prevProps.form, this.props.form) ||
			!isEqual(prevProps.definition, this.props.definition)
		);

		if (shouldValidate) {
			this.validate();
		}
	}

	evaluate(block: any) {
		const {
			form
		} = this.props;

		if (block.condition) {
			if (form[block.condition.name] !== block.condition.value) {
				return false;
			}
		}

		return true;
	}

	isFieldValid(field: any, form: any) {
		let value: any = form[field.name];
		let isValid = true;
		if (field.required) {

			switch (field.name) {
				case 'name':
					value = value.trimStart();
					form[field.name] = value;
					isValid = Boolean(String(value).match(field.validation));
					break;

				case 'email':
					value = value.trim();
					form[field.name] = value;
					isValid = Boolean(String(value).match(field.validation));
					break;

				default:
					isValid = Boolean(String(value).match(field.validation));
			}
		}

		return isValid;
	}

	validate() {
		const {
			definition,
			form,
			onValidStateChange
		} = this.props;

		let isValid: boolean = true;
		let isEmailValid: boolean = false;
		definition.sections.forEach((section: any) => {
			if (!this.evaluate(section) || !section.fields) {
				return;
			}

			section.fields.forEach((field: any) => {

				if (field.name === "email" && isValid) {
					isEmailValid = this.isFieldValid(field, form);
				}
				else if (isValid) {
					isValid = this.isFieldValid(field, form);
				}
			});
		});

		onValidStateChange(isValid, isEmailValid);
	}

	render() {
		const {
			classes,
			definition,
			form,
			onBlur,
			onChange,
			translate,
			touched,
			showEmail
		} = this.props;

		return (
			<div className={classes.panelContainer}>
				{definition.sections.map((section: any) => {
					if (!this.evaluate(section)) {
						return null;
					}

					return (
						<div className={classes.formSection}>
							{section.type === 'input' && (
								<div className={classes.formSectionContent}>
									{section.fields.map((field: any) => {
										let SelectedComponent: any = COMPONENT_DEFINITIONS[field.component];
										if (!SelectedComponent) {
											SelectedComponent = COMPONENT_DEFINITIONS.default;
										}

										const error = touched[field.name] && !this.isFieldValid(field, form);
										const label = (
											translate.has(`${field.key}.label`) &&
											translate(`${field.key}.label`)
										);

										let helper = translate.has(`${field.key}.helper`) && translate(`${field.key}.helper`);
										if (error && translate.has(`${field.key}.error`)) {
											helper = translate(`${field.key}.error`);
										}

										if (field.name === 'receiveEmail' || field.name === 'name') {
											return (
												<SelectedComponent
													key={field.key}
													className={classes.formSectionInput}
													error={error}
													helperText={helper}
													label={label}
													onBlur={onBlur}
													onChange={onChange}
													name={field.name}
													value={form[field.name]}
													type={field.reference}
													isCoralogixMasked={field.isCoralogixMasked ?? false}
												/>
											)
										}
										if (field.name === 'email' && showEmail) {
											return (
												<SelectedComponent
													key={field.key}
													className={classes.formSectionInput}
													error={error}
													helperText={helper}
													label={label}
													onBlur={onBlur}
													onChange={onChange}
													name={field.name}
													value={form[field.name]}
													type={field.reference}
													isCoralogixMasked={field.isCoralogixMasked ?? false}
												/>
											)
										}
										if (field.name === 'linkSent') {
											return (
												<SelectedComponent
													key={field.key}
													className={classes.formSectionInput}
													error={error}
													helperText={helper}
													label={label}
													onBlur={onBlur}
													onChange={onChange}
													name={field.name}
													value={form[field.name]}
													type={field.reference}
													formEmail={this.props.form.email}
													showEmail={showEmail}
												/>
											)
										}
										return null;
									})}
								</div>
							)}
						</div>
					)
				})}
			</div>
		)
	}
}

export default withTranslate(
	withStyles(APReferralStepPanelStyles)(APReferralStepPanel)
);
